export const NOINDEX_ROBOTS_CONTENT = 'noindex,nofollow,noarchive'
export const NOINDEX_HEADER_VALUE = 'noindex, nofollow, noarchive'

export function parseSiteConfigData(configData) {
  if (!configData) {
    return {}
  }

  if (typeof configData === 'string') {
    try {
      return JSON.parse(configData)
    }
    catch (error) {
      console.error('Failed to parse site configData:', error)
      return {}
    }
  }

  if (typeof configData === 'object') {
    return configData
  }

  return {}
}

export function shouldDisableGoogleIndex(input) {
  const configData = input && input.configData !== undefined
    ? parseSiteConfigData(input.configData)
    : parseSiteConfigData(input)

  return Boolean(configData.disableGoogleIndex)
}

export function buildNoIndexMetaTags() {
  return [
    {
      key: 'robots',
      name: 'robots',
      content: NOINDEX_ROBOTS_CONTENT,
    },
    {
      key: 'googlebot',
      name: 'googlebot',
      content: NOINDEX_ROBOTS_CONTENT,
    },
  ]
}

export function buildRobotsTxt(disableGoogleIndex, sitemapUrl = '') {
  if (disableGoogleIndex) {
    return [
      'User-agent: *',
      'Disallow: /',
      '',
      'User-agent: Googlebot',
      'Disallow: /',
      '',
    ].join('\n')
  }

  const lines = [
    'User-agent: *',
    'Allow: /',
  ]

  if (sitemapUrl) {
    lines.push('', `Sitemap: ${sitemapUrl}`)
  }

  lines.push('')

  return lines.join('\n')
}
